import React, { useState } from "react";

const ReadMoreWrapper = ({
  readMoreText,
  readLessText,
  text = "",
  max = 200,
  cls = "",
}) => {
  const [showExtraText, setShowExtraText] = useState(false);
  return (
    <div className={cls}>
      {text.length > max ? (
        <>
          <p className="inline break-all">
            {text.substring(0, max)}
            {showExtraText ? text.substring(max, text.length) : "..."}
          </p>
          <button
            onClick={() => {
              setShowExtraText(!showExtraText);
            }}
          >
            &nbsp;
            {showExtraText ? readLessText : readMoreText}
          </button>
        </>
      ) : (
        <p className="inline">{text}</p>
      )}
    </div>
  );
};

export default ReadMoreWrapper;
